import { render, staticRenderFns } from "./etablissement-list.vue?vue&type=template&id=2cd0f647&scoped=true&"
import script from "./etablissement-list.vue?vue&type=script&lang=ts&"
export * from "./etablissement-list.vue?vue&type=script&lang=ts&"
import style0 from "./etablissement-list.vue?vue&type=style&index=0&id=2cd0f647&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd0f647",
  null
  
)

export default component.exports